<div class="ms-aside-toggler cursor-pointer ms-toggler pl-0 inline-block" data-target="#ms-side-nav"
  data-toggle="slideLeft" (click)="toggleSidenav()">
  <span class="ms-toggler-bar bg-primary-qms"></span>
  <span class="ms-toggler-bar bg-primary-qms"></span>
  <span class="ms-toggler-bar bg-primary-qms"></span>
</div>
<button pButton pRipple type="button" routerLink="/Dashboard" pTooltip="Dashboard" tooltipPosition="right"
  placeholder="Top" icon="pi pi-home" class="p-button-rounded p-button-help home-btn"></button>
<button mat-button [matMenuTriggerFor]="menu" class="profile-btn cursor-pointer relative">
  <div class="marginAuto">
    <p-avatar [image]="profileImageUrl" pTooltip="Profile" tooltipPosition="left" styleClass="mr-2" size="large"
      shape="circle"></p-avatar>
    <i class="pi pi-circle-fill"></i>
  </div>
</button>
<mat-menu #menu="matMenu">
  <div class="profile-dropdown font-regular">
    <ul class="m-0 pl-0 profile-ul">
      <li>
        <h2 class="profile-menu-header mb-0 mt-0 font-normal">Welcome: <strong> {{userName}} </strong> </h2>
      </li>
      <li class="dropdown-elements" (click)="changeUserRoute()">
        <a><i class="pi pi-user mr-2"></i> Profile </a>
      </li>
      <!-- <li class="dropdown-elements">
        <a><i class="pi pi-lock mr-2"></i> Change Password </a>
      </li> -->
      <li class="dropdown-elements" (click)="logOut()">
        <a><i class="pi pi-sign-out mr-2"></i> Logout </a>
      </li>
    </ul>
  </div>
</mat-menu>
<div class="mt-2 timeDate mr-2" style="display:flex">
  <div class="minmax-screen">
    <button pButton type="button" icon="{{ScreenIcon}}" pTooltip="{{fullScreen}}" tooltipPosition="left" icon="pi pi-external-link" class="p-button-rounded p-button-help ml-3" 
    (click)="openFullscreen(); closeFullscreen();"></button>
  </div>
  <div class="mt-2">
    <h3 class="profile-menu-header m-0 font-normal text-base">Date : {{currentDate}} </h3>
    <h3 class="profile-menu-header m-0 font-normal text-base">Time : {{currentTime | date:'HH:mm:ss' : 'EDT'}} ET </h3>
  </div>
</div>